import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import { APP_VERSION } from './utils/cacheBuster';



// Type declarations for browser APIs
declare global {
  interface Window {
    location: Location;
  }
}

// Log version for debugging
console.log(`Whole Momma Wellness v${APP_VERSION} loaded at ${new Date().toISOString()}`);

// Controlled cache invalidation - only clear if version mismatch
if (typeof window !== 'undefined') {
  const currentVersion = localStorage.getItem('app-version');
  
  // Only reload once if version is different
  if (currentVersion !== APP_VERSION) {
    console.log('Version mismatch detected, clearing cache and reloading once');
    
    // Clear storage and caches
    localStorage.clear();
    sessionStorage.clear();
    
    if ('caches' in window) {
      caches.keys().then(cacheNames => {
        cacheNames.forEach(cacheName => {
          console.log('Clearing cache:', cacheName);
          caches.delete(cacheName);
        });
      });
    }
    
    // Set new version and reload once
    localStorage.setItem('app-version', APP_VERSION);
    window.location.reload();
  } else {
    // Version matches, just update the stored version
    localStorage.setItem('app-version', APP_VERSION);
  }
}

// Register service worker for cache management
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/sw.js')
    .then((registration) => {
      console.log('Service Worker registered:', registration);
      
      // Check for updates but don't force immediate reload
      registration.addEventListener('updatefound', () => {
        const newWorker = registration.installing;
        if (newWorker) {
          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              console.log('New service worker available - user can refresh to update');
            }
          });
        }
      });
    })
    .catch((error) => {
      console.log('Service Worker registration failed:', error);
    });
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
) 